import { useEffect } from 'react';
import { usePanelStore } from '@/features/panel/store/panel-store';

interface Opts {
  onSend: () => void;
  enabled?: boolean;
}

export function useBroadcastHotkeys({ onSend, enabled = false }: Opts) {
  useEffect(() => {
    function handler(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod) return;
      if (e.key === 'b' || e.key === 'B') {
        e.preventDefault();
        usePanelStore.getState().cycleBroadcastDestinations();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (enabled) onSend();
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onSend, enabled]);
}
